<template>
	<section :class="['_text-with-image']">
		<div class="g-row">
			<div class="g-col xxl-9 xxl-offset-2 md-offset-1 xs-24 xs-offset-0">
				<nuxt-img class="desktop" :src="image.src" :alt="image.alt" />
			</div>

			<div class="g-col xxl-7 xxl-offset-5 lg-10 lg-offset-2 md-12 md-offset-1 xs-24 xs-offset-0">
				<p class="-p-small">{{ text }}</p>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	image: {
		type: Object,
		default: () => ({
			src: '',
			alt: '',
		}),
	},
	text: { type: String, default: '' },
})
</script>

<style lang="scss" scoped>
._text-with-image {
	margin-top: rs(100, 40);
	margin-bottom: rs(82, 82);

	@include max-width($xs) {
		.g-row {
			flex-direction: column-reverse;
		}
	}

	.-p-small {
		white-space: pre-line;
		margin-top: rs(20, 150);

		@include max-width($xs) {
			margin-top: 0;
			margin-bottom: rs(20, 40);
		}
	}

	img {
		width: 100%;
	}
}
</style>
